module.exports = __webpack_public_path__ + "f33d1ced159db7a12d7d08d8ef8da6f7.svg";